module.exports = __webpack_public_path__ + "static/media/walking.286c0979.svg";